/**
 * Logging for NodeJS
 * Use console.[log|info|error|warn] for browser logging
 */
import { AxiosError } from 'axios';
import pino from 'pino';

/**
 * Log levels:
 *       'fatal'
 *       'error'
 *       'warn'
 *       'info'
 *       'debug'
 *       'trace'
 */

export const logger = pino({
  level: process?.env?.['LOG_LEVEL'] || 'info',
  formatters: {
    level(level) {
      return { level };
    },
  },
});

export function decideLogLevelForError(err: unknown) {
  let logLevel: 'warn' | 'debug' = 'warn';
  if (err instanceof AxiosError) {
    if (err.response?.status === 404) {
      logLevel = 'debug';
    }
  }
  return logLevel;
}
